module.exports = __webpack_public_path__ + "static/Mazars_logo.svg-b3910eac4d1532502dcb1ec220ba0887.png";